interface ErrorBannerProps {
  message: string
  onDismiss?: () => void
}

export function ErrorBanner({ message, onDismiss }: ErrorBannerProps) {
  return (
    <div className="bg-red-900/20 border border-red-800 rounded-lg p-4 flex items-start justify-between">
      <p className="text-sm text-red-200">{message}</p>
      {onDismiss && (
        <button type="button" onClick={onDismiss} className="text-red-400 hover:text-red-200">
          ✕
        </button>
      )}
    </div>
  )
}
